import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * Sanitiza um nome para uso seguro como nome de arquivo.
 * Remove caracteres inválidos e colapsa espaços.
 */
export function sanitizeFilename(name: string): string {
  return name
    .replace(/[<>:"/\\|?*\x00-\x1f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 100);
}

/**
 * Exporta um elemento HTML como PDF
 * Captura o elemento visualmente com html2canvas e gera PDF com jsPDF
 * Lida com containers scrolláveis removendo temporariamente as restrições de overflow
 */
export async function exportToPdf(element: HTMLElement, filename: string): Promise<void> {
  const safeFilename = sanitizeFilename(filename);
  // Salvar estilos inline originais
  const origStyle = element.getAttribute('style') || '';

  // Forçar o container a mostrar todo o conteúdo (override de classes Tailwind)
  element.style.setProperty('overflow', 'visible', 'important');
  element.style.setProperty('max-height', 'none', 'important');
  element.style.setProperty('height', 'auto', 'important');

  try {
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      logging: false,
      backgroundColor: null,
      windowWidth: element.scrollWidth,
      windowHeight: element.scrollHeight,
    });

    const pdf = new jsPDF('l', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;
    const contentWidth = pageWidth - margin * 2;

    const imgWidth = contentWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = margin;

    // Primeira página
    pdf.addImage(canvas.toDataURL('image/png'), 'PNG', margin, position, imgWidth, imgHeight);
    heightLeft -= pageHeight - margin * 2;

    // Páginas adicionais se necessário
    while (heightLeft > 0) {
      position = heightLeft - imgHeight + margin;
      pdf.addPage();
      pdf.addImage(canvas.toDataURL('image/png'), 'PNG', margin, position, imgWidth, imgHeight);
      heightLeft -= pageHeight - margin * 2;
    }

    pdf.save(safeFilename);
  } finally {
    // Restaurar estilos originais
    element.setAttribute('style', origStyle);
  }
}
